<div class="search-container relative">
  <mat-form-field
    subscriptSizing="dynamic"
    class="white-backgrounded-field w-full"
    appearance="outline"
    >
    <div class="flex justify-between items-center flex-nowrap w-full">
      <div class="flex items-center w-full basis-9/10">
        <!-- <mat-icon>search</mat-icon> -->
        <div class="flex flex-nowrap items-center mr-2 flex-grow">
          <input
            type="text"
            [formControl]="name"
            matInput
            placeholder="Suche nach Angeboten"
            (keyup.enter)="onEnter()"
            (keyup.backspace)="onBackspace()"
            class="w-full"
            />
        </div>
      </div>
      <span
        class="material-symbols-outlined basis-9/10 cursor-pointer"
        (click)="onEnter()"
        tabindex="0"
        role="button"
        (keyup.enter)="onEnter()"
        >search</span
        >
      </div>
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <!-- Suggestions Dropdown -->
    @if (
      suggestions.offers.length ||
      suggestions.categories.length ||
      suggestions.locations.length
      ) {
      <div
        class="suggestions-dropdown absolute w-full bg-white border border-gray-300 rounded-lg mt-1 shadow-lg z-10 p-4"
        >
        <ul class="!list-none">
          @if (suggestions.offers.length) {
            <li
              class="font-semibold text-blue-600 mb-2"
              i18n
              >
        Angebote
      </li>
          }
          @if (suggestions.offers.length) {
            <div class="flex flex-wrap gap-2 px-2">
              @for (offer of suggestions.offers; track offer) {
                <div
                  class="flex-shrink-0 bg-blue-100 text-blue-700 rounded-full px-3 py-1 mr-2 cursor-pointer hover:bg-blue-200"
                  (click)="onSelectSuggestion(offer, 'offer')"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="onSelectSuggestion(offer, 'offer')"
                  >
                  {{ offer.name }}
                </div>
              }
            </div>
          }
          @if (suggestions.categories.length) {
            <li
              class="font-semibold text-green-600 mb-2 mt-6"
              i18n
              >
        Kategorien
      </li>
          }
          @if (suggestions.categories.length) {
            <div
              class="flex flex-wrap gap-2 px-2"
              >
              @for (category of suggestions.categories; track category) {
                <div
                  class="flex-shrink-0 bg-green-100 text-green-700 rounded-full px-3 py-1 mr-2 cursor-pointer hover:bg-green-200"
                  (click)="onSelectSuggestion(category, 'category')"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="onSelectSuggestion(category, 'category')"
                  >
                  {{ category.name }}
                </div>
              }
            </div>
          }
          @if (suggestions.locations.length) {
            <li
              class="font-semibold text-yellow-600 mb-2 mt-6"
              i18n
              >
        Orte
      </li>
          }
          @if (suggestions.locations.length) {
            <div
              class="flex flex-wrap gap-2 px-2"
              >
              @for (location of suggestions.locations; track location) {
                <div
                  class="flex-shrink-0 bg-yellow-100 text-yellow-700 rounded-full px-3 py-1 mr-2 cursor-pointer hover:bg-yellow-200"
                  (click)="onSelectSuggestion(location, 'postalCode')"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="onSelectSuggestion(location, 'postalCode')"
                  >
                  {{ location.plz }}, {{ location.name }}
                </div>
              }
            </div>
          }
        </ul>
      </div>
    }
  </div>
